export const ChatStorage = {
  getChatKey(name) {
    return `pik_chatbot_${name}`;
  },

  saveChat(name, history) {
    const data = {
      timestamp: Date.now(), // This will be updated with each new message
      history
    };
    localStorage.setItem(this.getChatKey(name), JSON.stringify(data));
  },

  getChat(name) {
    const data = localStorage.getItem(this.getChatKey(name));
    if (!data) return null;
    
    const parsed = JSON.parse(data);
    const oneDay = 24 * 60 * 60 * 1000; // milliseconds in a day
    
    // Check if the last message was more than 24 hours ago
    if (Date.now() - parsed.timestamp > oneDay) {
      this.clearChat(name);
      return null;
    }
    
    return parsed.history;
  },

  clearChat(name) {
    localStorage.removeItem(this.getChatKey(name));
  }
};